import { Subscription } from 'rxjs';
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { ServiceRequest } from 'src/app/back-office/Models/ServiceRequest';
import { ServiceRequestService } from 'src/app/dealer-system/Services/service-request.service';
import { Helper } from 'src/app/helpers/helper.service';

@Component({
  selector: 'app-dealer-reply-step-text',
  templateUrl: './dealer-reply-step-text.component.html',
  styleUrls: ['./dealer-reply-step-text.component.scss']
})
export class DealerReplyStepTextComponent implements OnInit , OnDestroy {

  @Input() Index;
  @Input() isActive;

  public request: ServiceRequest = new ServiceRequest();
  private subscriptions: Subscription[] = [];

  constructor(
    private requestService: ServiceRequestService,
    public helper: Helper,
  ) { }

  ngOnInit() {
    this.subscriptions.push(
      this.requestService.serviceRequest.subscribe(serviceRequest => {
        this.request = serviceRequest;
        this.request.reply.replyItems = this.request.reply.replyItems.filter(item => !item.solutionStep.restricted);
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

}
